import type { HighlightProps } from 'components/ToolkitV2/CardV2/components/Highlight/Highlight.typed';
import * as Styled from 'components/ToolkitV2/CardV2/components/Highlight/Highlight.styled';

const Highlight = ({ color = 'GREY_DARKER', children }: HighlightProps) => (
  <Styled.Highlight color={color}>
    <Styled.Badge color={color}>{children}</Styled.Badge>
  </Styled.Highlight>
);
export { Highlight };
